import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Calendar } from 'primereact/calendar';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';

export default function DateField({
  index,
  handleSettingsClick,
  item = {},
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { res_type, required, subtext, dateFormat, label = 'Date' } = item || {};
  const _label = res_type === 'custom-field' ? item?.name : label;

  const name = isRelation ? relationFieldName : item?.field_name || `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {_label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap w-100">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field }) => (
            <Calendar
              id={field.name}
              value={new Date(field.value || '')}
              onChange={(e) => {
                field.onChange(e.value);
                if (item?.field_name && !isRelation) {
                  setValue(`form_data.${index}.value`, e.value);
                }
              }}
              placeholder="Select"
              dateFormat={dateFormat}
              monthNavigator
              yearNavigator
              yearRange="1800:2250"
              className="input-shadow w-100"
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
